
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
  //学术报道 暂定 只需要id (reportId)
export default new Router({
  scrollBehavior(to,from,savedPosition) {
  if(savedPosition) {
    return savedPosition
  } else {
    return {x:0,y:0}
  }
},
mode:'hash',
  routes: [
    {
      path: '/',
      name: '/home',
      component:resolve => require(['@/components/home/index'],resolve),
    },
    {
      //首页
      path:'/home',
      name:'home',
      component:resolve => require(['@/components/home/index'],resolve),
    },
    {
      path:'/subscription',
      name:'subscription',
      component:resolve => require(['@/components/subscription/index'],resolve),
    },
    {
      // 期刊简介
      path: '/convention',
      name: 'convention',
      component:resolve => require(['@/components/convention/index'],resolve),
    },
    {
      // 期刊简介
      path: '/Introduction',
      name: 'Introduction',
      component:resolve => require(['@/components/Introduction/index'],resolve),
    },
    {
      path:'/Introduction/Introductiondetail',
      name:'Introductiondetail',
      component:resolve => require(['@/components/Introduction/Introductiondetail/index'],resolve),
    },
    {
      // 期刊目录
      path: '/Journal',
      name: 'Journal',
      component:resolve => require(['@/components/Journal/index'],resolve),
    },
    {
      // 期刊目录移动端选期
      path: '/JournalMob',
      name: 'JournalMob',
      component:resolve => require(['@/components/JournalMob/index'],resolve),
    },
    {
      // 期刊目录详情
      path: '/Journal/Journaldetail',
      name: 'Journaldetail',
      component:resolve => require(['@/components/Journal/Journaldetail/index'],resolve),
    },
    {
      // 杂志动态
      path: '/popularinfor',
      name: 'popularinfor',
      component:resolve => require(['@/components/popularinfor/index'],resolve),
    },
    {
      // 杂志动态详情
      path: '/popularinfor/popularinfordetail',
      name: 'popularinfordetail',
      component:resolve => require(['@/components/popularinfor/popularinfordetail/index'],resolve),
    },
    {
      // 本周关注
      path: '/according',
      name: 'according',
      component:resolve => require(['@/components/according/index'],resolve),
    },
    {
      // 编委会
      path: '/editorial',
      name: 'editorial',
      component:resolve => require(['@/components/editorial/index'],resolve),
    },
    {
      // 编委会
      path: '/editorial/editorialdetail',
      name: 'editorialdetail',
      component:resolve => require(['@/components/editorial/editorialdetail/index'],resolve),
    },
    {
      // 本周关注详情
      path: '/according/accordingdetail',
      name: 'accordingdetail',
      component:resolve => require(['@/components/according/accordingdetail/index'],resolve),
    },
    {
      // 学术圈
      path: '/academicCircle',
      name: 'academicCircle',
      component:resolve => require(['@/components/academicCircle/index'],resolve),
    },
    {
      // 学术圈详情
      path: '/academicCircle/academicCircledetail',
      name: 'academicCircledetail',
      component:resolve => require(['@/components/academicCircle/academicCircledetail/index'],resolve),
    },
    {
      // 书籍指南
      path: '/guidelines',
      name: 'guidelines',
      component:resolve => require(['@/components/guidelines/index'],resolve),
    },
    {
      // 书籍指南详情
      path:'/guidelines/guidelinesdetail',
      name:'guidelinesdetail',
      component:resolve => require(['@/components/guidelines/guidelinesdetail/index'],resolve),
    },
    {
      // 资料下载
      path: '/datadown',
      name: 'datadown',
      component:resolve => require(['@/components/datadown/index'],resolve),
    },
    {
      // 联系我们
      path:'/contactus',
      name:'contactus',
      component:resolve => require(['@/components/contactus/index'],resolve),
    },
    {
      path:'/contactus/contactusdetail',
      name:'contactusdetail',
      component:resolve => require(['@/components/contactus/contactusdetail/index'],resolve),
    },
    {
      // 阜外说心脏
      path:'/fuwaheart',
      name:'fuwaheart',
      component:resolve => require(['@/components/fuwaheart/index'],resolve),
    },
    // 阜外说心脏详情
    {
      path:'/fuwaheart/fuwaheartdetail',
      name:'fuwaheartdetail',
      component:resolve => require(['@/components/fuwaheart/fuwaheartdetail/index'],resolve),
    },
    {
      // 短视频交流
      path:'/shortvicomm',
      name:'shortvicomm',
      component:resolve => require(['@/components/shortvicomm/index'],resolve),
    },
    {
      // 视频详情页
      path:'/videodetail',
      name:'videodetail',
      component:resolve => require(['@/components/videodetail/index'],resolve),
    },
    {
      path:'/hotpush',
      name:'hotpush',
      component:resolve => require(['@/components/hotpush/index'],resolve),
    },
    {
      path:'/hotpush/hotpushdetail',
      name:'hotpushdetail',
      component:resolve => require(['@/components/hotpush/hotpushdetail/index'],resolve),
    },
    {
      // 资讯
      path:'/information',
      name:'information',
      component:resolve => require(['@/components/information/index'],resolve),
    },
    {
      // 资讯详情
      path:'/information/informationdetail',
      name:'informationdetail',
      component:resolve => require(['@/components/information/informationdetail/index'],resolve),
    },
    {
      // 会议培训
      path:'/meeting',
      name:'meeting',
      component:resolve => require(['@/components/meeting/index'],resolve),
    },
    {
      // 会议培训详情
      path:'/meeting/meetingdetail',
      name:'meetingdetail',
      component:resolve => require(['@/components/meeting/meetingdetail/index'],resolve),
    },
    {
      // 学术圈
      path:'/educationvideo',
      name:'educationvideo',
      component:resolve => require(['@/components/educationvideo/index'],resolve),
    },
    {
      // 学术圈详情
      path:'/educationvideo/educationvideodetail',
      name:'educationvideodetail',
      component:resolve => require(['@/components/educationvideo/educationvideodetail/index'],resolve),
    },
    {
      // 合作伙伴
      path:'/cooperpanter',
      name:'cooperpanter',
      component:resolve => require(['@/components/cooperpanter/index'],resolve),
    },
    {
      // 合作伙伴详情
      path:'/cooperpanter/cooperpanterdetail',
      name:'cooperpanterdetail',
      component:resolve => require(['@/components/cooperpanter/cooperpanterdetail/index'],resolve),
    },
    {
      // 头条讨论
      path:'/headdiscount',
      name:'headdiscount',
      component:resolve => require(['@/components/headdiscount/index'],resolve),
    },
    {
      // 头条讨论详情
      path:'/headdiscount/headdiscountdetail',
      name:'headdiscountdetail',
      component:resolve => require(['@/components/headdiscount/headdiscountdetail/index'],resolve),
    },
    {
      path:'/homecarousel',
      name:'homecarousel',
      component:resolve => require(['@/components/homecarousel/index'],resolve),
    },
    {
      path:'/searchGuilde',
      name:'searchGuilde',
      component:resolve => require(['@/components/searchGuilde/index'],resolve),
    },
    {
      path:'/goodlookback',
      name:'goodlookback',
      component:resolve => require(['@/components/goodlookback/index'],resolve),
    },
    {
      path:'/search',
      name:'search',
      component:resolve => require(['@/components/search/index'],resolve),
    },
    {
      path:'/search/searchdetail',
      name:'searchdetail',
      component:resolve => require(['@/components/search/searchdetail/index'],resolve),
    },
    {
      path:'/journalsearch',
      name:'journalsearch',
      component:resolve => require(['@/components/journalsearch/index'],resolve),
    },
    {
      path:'/journalsearch/journalsearchdetail',
      name:'journalsearchdetail',
      component:resolve => require(['@/components/journalsearch/journalsearchdetail/index'],resolve),
    },
    {
      path:'/jpmetting',
      name:'jpmetting',
      component:resolve => require(['@/components/jpmetting/index'],resolve),
    },
    {
      path:'/jpmetting/jpmetdetail',
      name:'jpmetdetail',
      component:resolve => require(['@/components/jpmetting/jpmetdetail/index'],resolve),
    },
    {
      // 编委会
      path: '/editorial/editorialdetail/editornamedeta',
      name: 'editornamedeta',
      component:resolve => require(['@/components/editorial/editorialdetail/editornamedeta/index'],resolve),
    },
    {
      path: '/elegance',
      name: 'elegance',
      component:resolve => require(['@/components/elegance/index'],resolve),
    },

    // 英文
    {
      path:'/english',
      name:'english',
      component:resolve => require(['@/components/english/index'],resolve),
      children:[
        {
          path:'/english/enHome',
          name:'enHome',
          component:resolve => require(['@/components/english/enHome/index'],resolve),
        },
        {
          path:'/english/enJournal',
          name:'enJournal',
          component:resolve => require(['@/components/english/enJournal/index'],resolve),
        },
        {
          path:'/english/enEditorial',
          name:'enEditorial',
          component:resolve => require(['@/components/english/enEditorial/index'],resolve),
        },
        {
          path:'/english/enArchive',
          name:'enArchive',
          component:resolve => require(['@/components/english/enArchive/index'],resolve),
        },
        {
          path:'/english/enArchive/enArchivedetail',
          name:'enArchivedetail',
          component:resolve => require(['@/components/english/enArchive/enArchivedetail/index'],resolve),
        },
        {
          path:'/english/enSubmission',
          name:'enSubmission',
          component:resolve => require(['@/components/english/enSubmission/index'],resolve),
        },
        {
          path:'/english/enPublication',
          name:'enPublication',
          component:resolve => require(['@/components/english/enPublication/index'],resolve),
        },
        {
          path:'/english/enSubscription',
          name:'enSubscription',
          component:resolve => require(['@/components/english/enSubscription/index'],resolve),
        },
        {
          path:'/english/enContact',
          name:'enContact',
          component:resolve => require(['@/components/english/enContact/index'],resolve),
        },
        {
          path:'/english/enChinese',
          name:'enChinese',
          component:resolve => require(['@/components/english/enChinese/index'],resolve),
        },
        {
          path:'/english/englishsearch',
          name:'englishsearch',
          component:resolve => require(['@/components/english/englishsearch/index'],resolve),
        },
        {
          path:'/english/englishsearch/englishsearchdetail',
          name:'englishsearchdetail',
          component:resolve => require(['@/components/english/englishsearch/englishsearchdetail/index'],resolve),
        }
      ],
      redirect: "/english/enHome",
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js